import { z } from "zod";
import { CHAT_MESSAGE_MAX_LENGTH, CHAT_TITLE_MAX_LENGTH } from "@/constants";

type TranslateFn = (key: string, options?: Record<string, unknown>) => string;

export const createChatFormSchema = (t: TranslateFn) =>
  z.object({
    title: z
      .string()
      .min(1, t("chat.titleRequired", { defaultValue: "Please enter a chat title." }))
      .max(
        CHAT_TITLE_MAX_LENGTH,
        t("chat.titleTooLong", {
          maxLength: CHAT_TITLE_MAX_LENGTH,
          defaultValue: `Title must be at most ${CHAT_TITLE_MAX_LENGTH} characters.`,
        }),
      ),
    message: z
      .string()
      .min(1, t("chat.messageRequired", { defaultValue: "Please enter a message." }))
      .max(
        CHAT_MESSAGE_MAX_LENGTH,
        t("chat.messageTooLong", {
          maxLength: CHAT_MESSAGE_MAX_LENGTH,
          defaultValue: `Message must be at most ${CHAT_MESSAGE_MAX_LENGTH} characters.`,
        }),
      ),
    recipients: z
      .array(z.string().min(1))
      .min(
        1,
        t("chat.recipientRequired", { defaultValue: "Please select at least one recipient." }),
      ),
  });

export type CreateChatFormValues = z.infer<ReturnType<typeof createChatFormSchema>>;
